import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GetWoundtrackResult, WoundtrackProcessingOptionsRequest } from '@pixacare/dtos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WoundtrackApiService {
  private readonly httpClient = inject(HttpClient);

  getWoundsizeData(
    image: File,
    processingOptions: WoundtrackProcessingOptionsRequest,
  ): Observable<GetWoundtrackResult> {
    const formData = new FormData();
    formData.append('media', image);
    formData.append('options', JSON.stringify(processingOptions));

    return this.httpClient.post<GetWoundtrackResult>(`${environment.apiBaseUrl}/woundtrack/woundsize/`, formData);
  }

  getWoundtypeData(image: File, verticesPoints: [number, number][][]): Observable<GetWoundtrackResult> {
    const formData = new FormData();
    formData.append('media', image);
    formData.append('verticesPoints', JSON.stringify(verticesPoints));

    return this.httpClient.post<GetWoundtrackResult>(`${environment.apiBaseUrl}/woundtrack/woundtype/`, formData);
  }
}
